export default __webpack_public_path__ + "static/media/IS.5dcd090f.svg";